import React from 'react';

const SalesReportsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default SalesReportsPage;
